import AccountCircle from "@mui/icons-material/AccountCircle";
import Password from "@mui/icons-material/Password";
import { useState } from "react";
import { useAuth } from "./hooks/useAuth";
import { ILogin } from "../../types/types";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Input,
  InputAdornment,
  InputLabel,
  Typography,
} from "@mui/material";
import { PageMeta } from "../../seo/PageMeta";

export const Login = () => {
  const { requestAuth, error, setError } = useAuth();
  const [loginParams, setLoginParams] = useState<ILogin>({ username: "", password: "" });

  const hasError = !!error;
  const handleInputChange = (field: keyof ILogin, value: string) => {
    setLoginParams((prev) => ({ ...prev, [field]: value }));
    if (error) setError("");
  };
  return (
    <>
      <PageMeta title="Admin login" description="Finnhouse admin login." pathname="/auth" noindex />
      <Card className="login-form-parent">
        <CardContent sx={{ display: "flex", flexDirection: "column" }}>
          <CardHeader title="Admin Panel" slotProps={{ title: { component: "h1" } }} />
          <CardContent sx={{ mb: "1.5rem" }}>
            <Typography variant="body2">
              <b>Authorized</b> use only do not attempt unless authorized by staff. You can't
              register
              <br></br>
              via this website
            </Typography>
          </CardContent>
          <FormControl error={hasError} sx={{ p: "16px" }}>
            <InputLabel htmlFor="input-username">Username</InputLabel>
            <Input
              onChange={(e) => {
                handleInputChange("username", e.target.value);
              }}
              required
              id="input-username"
              startAdornment={
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl error={hasError} sx={{ p: "16px" }}>
            <InputLabel htmlFor="input-password">Password</InputLabel>
            <Input
              onChange={(e) => {
                handleInputChange("password", e.target.value);
              }}
              required
              type="password"
              id="input-password"
              startAdornment={
                <InputAdornment position="start">
                  <Password />
                </InputAdornment>
              }
            />
            <FormHelperText>{error}</FormHelperText>
          </FormControl>
          <Button
            onClick={() => {
              void requestAuth(loginParams);
            }}
            variant="contained"
            sx={{ width: "50%", mt: "2rem", mx: "auto" }}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </>
  );
};
